module.exports = __webpack_public_path__ + "img/historyImg6.f4913ac4.jpg";